import React, { useState } from "react"
import PropTypes from "prop-types"
import Style from "@/components/VisualSearch/v1/ResultPage/ProductDetail/index.module.scss"
import ImageSection from "@/components/VisualSearch/v1/ResultPage/ImageSection"
import ProductDtls from "@/components/VisualSearch/v1/ResultPage/ProductDtls"

const ProductDetail = props => {
  const {
    product,
    loading,
    show,
    setShow,
    productInfo,
    productIds,
    setProductId,
    setPartsFlag,
    partsFlag,
  } = props
  const [varentList, setVarentList] = useState([])
  return (
    <div className={`${Style.ProductDetail}`}>
      <div className="product-details-container">
        <ImageSection
          product={product}
          varentList={varentList}
          loading={loading}
        />
        <div className="prod-details w-100" id="prod-details">
          <ProductDtls
            product={product}
            varentList={varentList}
            setVarentList={setVarentList}
            loading={loading}
            show={show}
            setShow={setShow}
            productInfo={productInfo}
            productIds={productIds}
            setProductId={setProductId}
            setPartsFlag={setPartsFlag}
            partsFlag={partsFlag}
          />
        </div>
      </div>
    </div>
  )
}
ProductDetail.propTypes = {
  product: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  productInfo: PropTypes.object,
  productIds: PropTypes.array,
  setProductId: PropTypes.func,
  setPartsFlag: PropTypes.func,
  partsFlag: PropTypes.bool,
}

export default ProductDetail
